/**
 * This file is auto-generated from content/locale.yml.
 * Run `node packages/helpers/locales/sync-default-locale.js` after updating locale copy.
 */
module.exports = {
  routes: {
    search: 'search',
    works: 'works'
  },
  common: {
    actions: {
      open: 'Open',
      close: 'Close',
      clear: 'Clear',
      clear_all: 'Clear all',
      done: 'Done',
      show: 'Show',
      hide: 'Hide'
    },
    nouns: {
      search: 'Search',
      filters: 'Filters',
      results: 'results',
      values: 'values',
      types: 'types',
      items: 'items',
      navigation: 'navigation',
      section_navigation: 'section navigation',
      content_navigation: 'content navigation',
      primary_navigation: 'Primary navigation',
      metadata: 'metadata',
      gallery: 'gallery',
      gallery_thumbnails: 'gallery thumbnails',
      map: 'map',
      map_data: 'map data',
      map_locations: 'map locations',
      item_label: 'Item',
      details: 'details',
      breadcrumb: 'Breadcrumb',
      home: 'Home'
    },
    types: {
      work: 'Works',
      page: 'Pages',
      docs: 'Docs'
    },
    statuses: {
      loading: 'Loading…',
      empty_short: 'No {content}',
      empty_detail: 'No {content} available.',
      unavailable: '{content} unavailable.',
      unavailable_detail: '{content} is unavailable.',
      failed: 'Unable to load {content}.',
      loading_content: 'Loading {content}…',
      summary_content: 'Showing {shown} of {total} {content}',
      search_summary: 'Found {shown} of {total} in {type} for "{query}"',
      no_matches: 'No matches found.'
    },
    phrases: {
      placeholder_search: 'Search…',
      results_label: 'Search results',
      open_content: 'Open {content}',
      close_content: 'Close {content}',
      show_content: 'Show {content}',
      hide_content: 'Hide {content}',
      nav_label: '{content} navigation',
      search_content: 'Search {content}',
      filter_values: 'Filter {content} values',
      clear_content_search: 'Clear {content} search',
      none_applied: 'No {content} applied',
      applied_count: '{count} {content} applied',
      toggle_content: 'Toggle {content}',
      scroll_direction_content: 'Scroll {direction} through {content}',
      step_content: '{direction} {content}',
      item_numbered: '{content} {index}',
      content_key: '{content} key'
    },
    directions: {
      left: 'left',
      right: 'right',
      previous: 'Previous',
      next: 'Next'
    },
    misc: {
      referenced_by: 'Referenced by',
      on_this_page: 'On this page'
    }
  }
};
